import email from "../../Assets/images/profile-managment/email.png"
import call from "../../Assets/images/profile-managment/call.svg"
import role from "../../Assets/images/profile-managment/role.svg"
import status from "../../Assets/images/profile-managment/status.svg"
import user from "../../Assets/images/profile-managment/userid.svg"
import telephone from "../../Assets/images/profile-managment/telephone.svg"
import { Dropdown } from "react-bootstrap";
import { useEffect, useState } from "react"
import { AdminService } from "../../Services/Admin.service"
import DonationProgress from "./DonorManagement/DonationProgressbar"
import DonorChoosenSample from "./DonorManagement/DonatorChoosenSample"
import UserProfileItem from "../UserProfileItem"
import UpcomingDonations from "../../Pages/Admin/DonorManagement/UpcomingDonations"
import DonationHistory from "../../Pages/Admin/DonorManagement/DonationHistory"
import { DonorService } from "../../Services/Donor.Service"

function UserProfileDetails({ type, roles, userType, userData, handleChangeStatus, handleShowDeleteModal, handleShowInviteDonorModal, onCheckboxChange, error, touched, value, goToUserProfileSettings, handleShowTrainingModal, handleShowChangePasswordModal}) {
    
    const [donorData, setDonorData] = useState();
    const [sampleTypes, setSampleTypes] = useState(); 
    
    useEffect(() => {
        const fetchUserDetails = async (userId) => {
            try {
                const userDetails = await DonorService.getDonorDetails(userId); 
                setDonorData(userDetails.data.user) 
            } catch (error) {
                console.error("Failed to fetch user details", error);
            }
        }; 

        if(userType == 'donor' && type!= 'profile-settings'){
            fetchUserDetails(userData.id);         
        }
        
    }, []);

    useEffect(() => {
  
        async function fetchSampleTypes() {
            const result = await AdminService.getSampleTypes();
            setSampleTypes(result || []);
        }
        fetchSampleTypes();
    }, [userData, userType === 'donor']);

    
    return (
        <div className={`el-profile-board  ${userType == 'donor' ? 'p-md-5' : ''} el-bg-table mb-5`}>
            <div className="el-card-content">
                <div className="d-sm-flex align-items-md-center">
                    <div className="el-property-details-card-content">
                        <div className="el-flexbox align-items-start mb-xl-0">
                            <div className="d-flex flex-wrap justify-content-between">
                                <UserProfileItem src={user} title="Username" label={userData.display_name} />                                
                            </div>

                            {handleChangeStatus && (
                                <Dropdown>
                                    <Dropdown.Toggle className="navbar-drop-buttons" variant="secondary" id="dropdown-basic">
                                        Action
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="el-admin">
                                        
                                        {userType == 'requestor' && (<Dropdown.Item onClick={handleShowDeleteModal}>
                                            Delete Requestor
                                        </Dropdown.Item>)}
                                        {userType == 'requestor' && (<Dropdown.Item  onClick={handleShowTrainingModal}>
                                            Training Status
                                        </Dropdown.Item>)}

                                        <Dropdown.Item className={userData.active ? `text-danger` : `text-success`} onClick={() => handleChangeStatus(userData, userData.active)}>
                                            {/* {userData.active ? 'Deactivate' : 'Activate'} */} 
                                            <label >{userData.active ? 'Deactivate' : 'Activate'}</label> 
                                        </Dropdown.Item>

                                        {userType == 'donor' && userData.active && (<Dropdown.Item onClick={handleShowInviteDonorModal}>
                                            Invite
                                        </Dropdown.Item>)}
                                        {userType == 'admin' && (<Dropdown.Item onClick={handleShowDeleteModal}>
                                            Delete
                                        </Dropdown.Item>)} 
                                    </Dropdown.Menu>
                                </Dropdown>
                            )}

                            {handleShowChangePasswordModal && (
                                <>
                                    <Dropdown>
                                        <Dropdown.Toggle className="navbar-drop-buttons" variant="secondary" id="dropdown-basic">
                                            Action
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="el-admin">
                                            <Dropdown.Item onClick={handleShowChangePasswordModal}>
                                                Change Password
                                            </Dropdown.Item>                                          
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </>
                            )}

                        </div>
                        {userType != 'donor' && (
                            <div className="row">
                                <div className="col-md-12 mx-fit-content"  >
                                    <div className="flex-sec pb-3" style={userType == 'donor' ? { borderBottom: '1px solid #cbd5e1' } : {}}>
                                    
                                        <UserProfileItem src={email} title="Email Address" label={userData.email} />
                                        <UserProfileItem src={call} title="Phone Number" label={userData.phone_number} />


                                        {userType != 'request-new-sample' ? (
                                            <>  
                                                {type==='profile-settings' && ( 
                                                    <>
                                                     <UserProfileItem src={telephone} title="Office Number" label={userData.office_number || '-'} />
                                                     {/* <UserProfileItem src={user} title="Chromosonal Composition At Birth" label={userData.gender == 'XY' ? `Male (XY)` : 'Female (XX)'} /> */}
                                                     <UserProfileItem src={user} title="Biological Sex" label={userData.gender == 'XY' ? `Male (XY)` : 'Female (XX)'} />
                                                     <UserProfileItem src={role} title="Role" label={roles} />
                                                    </>
                                                )}
                                                {type !== 'profile-settings' && (
                                                    <UserProfileItem src={role} title="Role" label={userType === "admin" ? (userData.is_superadmin ? "Super Admin" : "Admin") : userType[0].toUpperCase() + userType.slice(1)} />
                                                )}
                                                <UserProfileItem src={status} title="Status" label={userData.active ? 'Active' : 'Inactive'} />
                                            </>
                                        ) : (<>
                                            <UserProfileItem src={telephone} title="Office Number" label={userData.office_number || '-'} />
                                        </>)}
                                    </div>
                                </div>
                                {userType === 'request-new-sample' && (
                                    <div className="d-flex align-items-center"> 
                                    <input
                                        type="checkbox"
                                        className="confirmInfoCheckbox"
                                        id="confirmInfoCheckbox"
                                        checked={!!value} // Bind to Formik's value
                                        onChange={(e) => onCheckboxChange(e.target.checked)} // Update Formik's value 
                                        data-error={error ? "true" : "false"} 
                                    />
                                    <label  className="ms-2" style={{cursor:'pointer'}} htmlFor="confirmInfoCheckbox">
                                        <h6 className="mb-0"><span>Please confirm this information is correct. All corrections should be done in </span><button type='button' className="back-link ms-2" onClick={()=>{goToUserProfileSettings()}} ><> Profile Settings</></button> </h6>
                                    </label>
                                    <div className="error-placeholder">
                                    {(error && touched ) &&  (
                                        <div className="text-danger">{error}</div> 
                                    )}
                                    </div>  
 
                                </div>
                                )}
                            </div>
                        )}
                        {userType == 'donor' && (
                            <div className="row">
                                <div className="col-md-12 mx-fit-content">
                                    <div className="flex-sec">
                                        <UserProfileItem src={email} title="Email Address" label={userData.email} />
                                        <UserProfileItem src={call} title="Phone Number" label={userData.phone_number} />
                                        <UserProfileItem src={telephone} title="Office Number" label={userData.office_number || "-"} />
                                        {/* <UserProfileItem src={user} title="Chromosonal Composition At Birth" label={userData.gender == 'XY' ? `Male (XY)` : 'Female (XX)'} /> */}
                                        <UserProfileItem src={user} title="Biological Sex" label={userData.gender == 'XY' ? `Male (XY)` : 'Female (XX)'} />
                                        {type==='profile-settings' && ( <UserProfileItem src={role} title="Role" label={roles} /> )}
                                        <UserProfileItem src={status} title="Status" label={userData.active ? 'Active' : 'Inactive'} />
                                        {donorData?.race_data && donorData.race_data.length > 0 && (
                                            <UserProfileItem 
                                                src={user} 
                                                // title={donorData.race_data[0]?.type_id === 1 ? 'Single Heritage' : 'Dual Heritage'} 
                                                title={donorData.race_data[0]?.type_name} 
                                                label={donorData.race_data.map(race => race.heritage_name).join(', ')} 
                                            />
                                        )}

                                    </div>                                    
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {userType == 'donor' && type!= 'profile-settings' && (
                    <>
                        <div className="el-blood-donation-section">
                            <div className="row">
                                <DonorChoosenSample sampleTypes={sampleTypes} userData={donorData} />
                                <DonationProgress  totalLimit={500}  donationDone={donorData?.total_blood_donate || 0} />
                            </div>
                        </div>
                        <div className="my-5 el-bg-table">
                            <UpcomingDonations donorId={userData.id} userType ={"donor_view_donation"}/>
                        </div>
                        <div className="my-5 el-bg-table">
                            <DonationHistory donorId={userData.id} userType ={"donor_view_donation"}/>
                        </div>

                    </>
                )}
            </div>
        </div>);
}
export default UserProfileDetails